'use strict';

const processInclude = require('base/util');

document.addEventListener('DOMContentLoaded', () => {
    processInclude(require('./storeLocator/storeLocator'));
});
